export const WalletTransactionSide = {
  DEBIT: "DEBIT",
  CREDIT: "CREDIT",
};

export const WalletTransactionSideFarsi = {
  DEBIT: "برداشت",
  CREDIT: "واریز",
};

export const WalletTransactionStatus = {
  INITIATED: "INITIATED",
  PENDING: "PENDING",
  DONE: "DONE",
  CANCEL: "CANCEL",
};

export const WalletTransactionStatusFarsi = {
  INITIATED: "در انتظار تایید ...",
  PENDING: "در انتظار تایید ...",
  DONE: "موفق",
  CANCEL: "ناموفق",
};

export const WalletTransactionType = {
  CHARGE: "CHARGE",
  DIRECT_DEBIT: "DIRECT_DEBIT",
  CASHOUT: "CASHOUT",
  REVOKE: "REVOKE",
  GIFT: "GIFT",
  ROUNDUP: "ROUNDUP",
  CORPORATION: "CORPORATION",
  PURCHASE: "PURCHASE",
  SETTLEMENT: "SETTLEMENT",
  BONUS: "BONUS",
  AUTO_PURCHASE: "AUTO_PURCHASE",
  WAGE: "WAGE",
  REFUND: "REFUND",
  REFUND_WAGE: "REFUND_WAGE",
};

export const WalletTransactionTypeFarsi = {
  CHARGE: "پس‌انداز آنی",
  DIRECT_DEBIT: "پس‌انداز خودکار",
  CASHOUT: "برداشت از قلک",
  REVOKE: "درخواست فروش",
  GIFT: "هدیه",
  ROUNDUP: "گرد کردن",
  CORPORATION: "CORPORATION",
  PURCHASE: "درخواست خرید",
  SETTLEMENT: "تسویه",
  BONUS: "هدیه",
  AUTO_PURCHASE: "درخواست خرید (خودکار)",
  WAGE: "کارمزد",
  REFUND: "برگشتی",
  REFUND_WAGE: "برگشتی کارمزد",
};
